import React, { useState } from "react";
import { Box, Typography } from "@mui/material";

import { Tab, Tabs } from "components/shared/Tab";
import FileUpload from "./FileUpload";
import TextEntry from "./TextEntry";

enum TargetUploadTab {
  FileUpload,
  TextEntry,
}

const UploadTabs = () => {
  
  const [activeTab, setActiveTab] = useState<TargetUploadTab>(
    TargetUploadTab.FileUpload
  );
  const [workflowId, setWorkflowId] = useState<number | string>("");
  const [diseaseTypeId, setDiseaseTypeId] = useState<number | string>("");

  return (
    <>
      <Tabs
        value={activeTab}
        onChange={(event: React.ChangeEvent<{}>, tab: TargetUploadTab) =>
          setActiveTab(tab)
        }
        textColor="primary"
        indicatorColor="primary"
      >
        <Tab label="File Upload" />
        <Tab label="Text Entry" />
      </Tabs>
      <Box mt={2}>
        <Typography variant="body1">
          FusionPlex assays are supported on the Illumina<sup>®</sup> and Ion
          Torrent<sup>™</sup> sequencing platforms. VariantPlex and LiquidPlex
          assays are not supported on the Ion Torrent sequencing platform.
        </Typography>
      </Box>
      <Box>
        {activeTab === TargetUploadTab.FileUpload && (
          <FileUpload
            workflowId={workflowId}
            setWorkflowId={setWorkflowId}
            diseaseTypeId={diseaseTypeId}
            setDiseaseTypeId={setDiseaseTypeId}
          />
        )}
        {activeTab === TargetUploadTab.TextEntry && (
          <TextEntry
            workflowId={workflowId}
            setWorkflowId={setWorkflowId}
            diseaseTypeId={diseaseTypeId}
            setDiseaseTypeId={setDiseaseTypeId}
          />
        )}
      </Box>
    </>
  );
};

export default UploadTabs;
